import { getBasePath } from '@experiences/util';
import urljoin from 'url-join';

export const getOrganizationStandardUrl = () => {
    return urljoin(window.location.origin, getBasePath());
};
